import src from "IMAGE";
export default { src, width: 250, height: 167, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAM0lEQVR42r3JMQ0AIAwEwPfChASkoIKBGRmYwRNTx37TVkWT2w5oN831lOak7PP7SCiIABadQteOJ+7IAAAAAElFTkSuQmCC"};
